import { combineReducers } from "redux";

import notificacao from "./notificacao/reducer";

export default combineReducers({ notificacao });
